import React from 'react';
import Avatar from 'components/Avatar';
import Link from 'next/link';

const AuthorAvatar = ({ author, ...restProps }) => {
    return (
        <Link href={`/autorzy/${author.seoSlug}`}>
            <Avatar person={author} {...restProps} />
        </Link>
    );
};

export default AuthorAvatar;
